import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id F0E0017F-DD8C-4811-9428-613238CA66A4
 * name solid
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/solid.svg
 * tags
 */
export const SolidIcon = createSvgIcon(<><path d="M0,0H24V24H0" /></>, 'SolidIcon');
export default SolidIcon